// Paramètres du simulateur LMNP 2027 : mettre à jour ici après le vote de la loi.
export const LMNP_2027 = {
  updatedAt: "2026-10-07",
  status: "Projet de loi de finances 2027 en discussion, non adopté.",
  psDefault: 17.2,
  tmiOptions: [0, 11, 30, 41, 45],
  current: { buildingRateDefault: 3.33, furnitureYears: 7 },
  project: {
    classique: { rate: 2.5, cap: 7000 },
    tourisme: { rate: 1.5, cap: 5000 },
  },
  stock: { lastYear: 2036, profitShare: 0.5 },
  firstYear: 2027,
  horizon: 10,
  types: [
    { id: "classique", label: "Meublé classique (longue durée)" },
    { id: "tourisme", label: "Meublé de tourisme (courte durée)" },
    { id: "services", label: "Résidence étudiants, seniors ou Ehpad", exempt: true },
  ],
};

// Calcul pluriannuel : aujourd'hui (report illimité) vs projet (plafond, excédent perdu, stock limité).
export function simulateLmnp(input, cfg = LMNP_2027) {
  const type = cfg.types.find((t) => t.id === input.type) || cfg.types[0];
  const ebe = input.rents - input.charges - input.interests;
  const base = Math.max(0, ebe);
  const rateTax = (input.tmi + input.ps) / 100;
  const bNow = input.building * (input.buildingRate / 100);
  const furnitureAnnual = input.furniture > 0 ? input.furniture / cfg.current.furnitureYears : 0;
  const rule = cfg.project[type.id] || cfg.project.classique;
  const bProjRaw = input.building * (rule.rate / 100);

  let carryNow = input.stock;
  let stockProj = input.stock;
  const years = [];
  for (let i = 0; i < cfg.horizon; i++) {
    const year = cfg.firstYear + i;
    const furn = i < cfg.current.furnitureYears ? furnitureAnnual : 0;
    const availNow = bNow + furn + carryNow;
    const usedNow = Math.min(availNow, base);
    carryNow = availNow - usedNow;
    const taxableNow = base - usedNow;

    let taxableProj;
    let lost = 0;
    if (type.exempt) {
      taxableProj = taxableNow;
    } else {
      const annual = input.furnitureInCap
        ? Math.min(bProjRaw + furn, rule.cap)
        : Math.min(bProjRaw, rule.cap) + furn;
      const usedAnnual = Math.min(annual, base);
      lost = (bNow + furn) - usedAnnual;
      let rest = base - usedAnnual;
      if (stockProj > 0 && year <= cfg.stock.lastYear) {
        const useStock = Math.min(stockProj, rest * cfg.stock.profitShare);
        stockProj -= useStock;
        rest -= useStock;
      }
      taxableProj = rest;
    }
    years.push({
      year, taxableNow, taxableProj, lost: Math.max(0, lost),
      taxNow: taxableNow * rateTax, taxProj: taxableProj * rateTax,
    });
  }
  const y1 = years[0];
  const extraYear = y1.taxProj - y1.taxNow;
  const extra10y = years.reduce((s, y) => s + (y.taxProj - y.taxNow), 0);
  const overCap = !type.exempt && (input.furnitureInCap ? bProjRaw + furnitureAnnual : bProjRaw) > rule.cap;
  let profile;
  if (type.exempt) profile = "exempt";
  else if (extraYear <= 0.5) profile = "none";
  else if (overCap) profile = "strong";
  else if (extraYear < 500) profile = "limited";
  else profile = "moderate";
  return {
    type, rule, ebe, years, extraYear, extra10y, overCap, profile,
    stockLost: type.exempt ? 0 : stockProj,
    taxableNow: y1.taxableNow, taxableProj: y1.taxableProj, lostAmort: y1.lost,
    taxNow: y1.taxNow, taxProj: y1.taxProj,
  };
}
